import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import {AddIcon, TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import ControllerTable from "./SubComponents/ControllerTable";
import ControllerApp from "./Functionality/ControllerApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Controller = () => {

    const {
        moduleId,
        DEV,
        permission,
        setCriteria,
        option,
        bodyForExport,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
        finalArray,
        selectedList,
        setSelectedList,
        deleteControllerShow,
        setDeleteControllerShow
    } = ControllerApp();

    return (
        <>
            <HeadTittle name={'controller'}>
                <ExportDataBtn
                    moduleId={moduleId}
                    searchElement={searchElement}
                    search={search}
                    option={option}
                    body={bodyForExport}
                />
                {(DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                    <ButtonAction
                        id='btn_ct_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        url={routes.controller.create}
                    />
                }
                {(DEV || permission?.includes(permissionObj?.WEB_HID_DELETE)) &&
                    <ButtonAction
                        id='btn_ct_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteControllerShow(true);
                        }}
                    />
                }
            </HeadTittle>

            <ControllerTable
                option={option}
                setCriteria={setCriteria}
                setBodyForExport={setBodyForExport}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSimpleSearch={setSimpleSearch}
                setSearch={setSearch}
                finalArray={finalArray}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                deleteControllerShow={deleteControllerShow}
                setDeleteControllerShow={setDeleteControllerShow}
            />
        </>
    );
};

export default Controller;
